export default "__VITE_ASSET__BtJZHSfq__"